import { Menu } from "antd"
import Link from "next/link"
import {
  EyeOutlined,
  InboxOutlined
} from "@ant-design/icons"
import PropTypes from "prop-types"
import ConfidentialityDisclaimer from "../confidentiality-disclaimer"

ImplementerEvaluatorMenu.propTypes = {
  step: PropTypes.any,
  submenu: PropTypes.any
}

export default function ImplementerEvaluatorMenu({ step, submenu }) {
  return (
    <>
      <Menu
        defaultSelectedKeys={[step]}
        defaultOpenKeys={[submenu]}
        theme="dark"
        className="fico main-menu"
        mode="inline">
        <Menu.SubMenu
          key="submissions"
          icon={<InboxOutlined />}
          title="Solicitudes">
          <Menu.Item key="submissions">
            <Link href="/implementer/submissions">
              Todas las solicitudes
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
        <Menu.SubMenu
          key="projects"
          icon={<EyeOutlined />}
          title="Proyectos">
          <Menu.Item key="active">
            <Link href="/implementer/projects">
              Activos
            </Link>
          </Menu.Item>
          <Menu.Item key="ON_CLOSURE">
            <Link href="/implementer/projects/status/on_closure">
              Concluidos
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
      </Menu>
      <ConfidentialityDisclaimer />
    </>
  )
}
